// extracted by mini-css-extract-plugin
export default {"loader-container":"Loader_loader-container__trqj3","loader":"Loader_loader__Gm5DR","rotator":"Loader_rotator__gNY1z"};